<template>
    <div>
        <b-card v-if="isLoaded && selectedSite">
            <b-row align-h="between" class="mt-2 mb-4">
                <b-col style="font-weight: bold; text-align: start;">
                    <span style="text-align: center;">
                          {{ $t('title') }}
                    </span>
                </b-col>
                <b-col cols="9" sm="9" md="7" lg="5" xl="6">
                    <b-row align-h="end" style="padding-right: 0.65rem">
                        <b-col cols="4">
                            <b-form-select v-model="selectedForm" class="gray-select">
                                <option :value="null">{{$t('all')}}</option>
                                <option v-for="formType in formTypes" :value="formType.id">{{ formType.name }}</option>
                            </b-form-select>
                        </b-col>
                        <b-col cols="4">
                            <b-form-select v-model="$store.state.year" @change="onYearChange" :options="yearOptions" class="gray-select"/>
                        </b-col>
                        <b-col cols="3">
                            <site-multi-select
                                :selectedSiteId="selectedSite.id"
                                :givenSites="filteredSites"
                                :allowEmpty="true"
                                @oninput="selectSiteId"/>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <div class="table-responsive scroll-content mt-3">
                <table class="table table-hover" style="table-layout: fixed; font-size: 0.875em;border-collapse: separate;border-spacing:0;">
                    <thead style="position: sticky;background-color: white;top: 0px;z-index:2">
                    <tr>
                        <th style="width: 10em">{{ $t('site') }}</th>
                        <th style="width: 10em">{{ $t('formType') }}</th>
                        <th style="width: 10em">{{ $t('formNo') }}</th>
                        <th style="width: 10em">{{ $t('version') }}</th>
                        <th style="width: 10em">{{ $t('createdAt') }}</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="form in filteredForms" @click="routeToFormDetail(form)" style="cursor: pointer;">
                            <td style="color: #007bff;">{{form.siteName}}</td>
                            <td>{{$t(form.type)}}</td>
                            <td>{{form.no}}</td>
                            <td>{{form.version}}</td>
                            <td>{{form.createdAt | formatDate('DD/MM/YYYY')}}</td>
                        </tr>
                        <tr>
                            <td v-show="this.$store.state.user.permissions.canEditData" @click="$refs.formTypes.show()" colspan="5" style="cursor: pointer">
                                <i class="fas fa-plus-circle fa-2x"></i>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </b-card>
        <b-modal ref="formTypes" size="sm" hide-footer hide-header centered>
            <b-form-select v-model="selectedFormToCreate">
                <option :value="null" disabled>{{$t('chooseFormType')}}</option>
                <option v-for="formType in formTypes" :value="formType.id">{{ $t(formType.name) }}</option>
            </b-form-select>
        </b-modal>
    </div>
</template>

<script>
import qs from 'qs';
import _ from 'lodash';
import SiteMultiSelect from '../../../components/SiteMultiSelect';

export default {
    components: {
        SiteMultiSelect
    },
    name: 'FormList',
    data() {
        return {
            isLoaded: false,
            selectedForm: null,
            selectedFormToCreate: null,
            forms: [],
            otherForms: [],
            selectedSite: null,
            filteredSites: [],
        };
    },
    methods: {
        routeToFormDetail(form) {
            this.$router.push({
                name: 'form-detail',
                params: {
                    site_id: this.route.params.site_id,
                    form_id: form.id
                }
            });
            return Promise.resolve();
        },
        configureForms(data) {
            let forms = [];
            data.forEach(element => {
                let form = {
                    version: element.version,
                    createdAt: element.createdAt,
                    no: element.no,
                    id: element.id,
                    type: _.find(this.formTypes, {id: element.type}).name,
                    formTypeId: element.type,
                    siteName: _.find(this.sites, {id: Number(this.route.params.site_id)}).name
                };
                forms.push(form);
            });
            this.forms = forms;
            return forms;
        },
        fetchForms() {
            return this.axios
                .get(`/${this.route.params.site_id}/form?${qs.stringify({year: this.year})}`)
                .then(({data}) => {
                    return data;
                });
        },
        selectSiteId(site) {
            if (!site) {
                this.$router.push({name: 'forms', query: {year: this.year}});
            } else {
                this.selectedSite = site;
                this.$store.state.siteId = site ? site.id : null;
                return this.routeTo(site);
            }
        },
        routeTo(site) {
            this.$router.push({
                name: 'site-forms',
                params: {site_id: site ? site.id : this.route.params.site_id},
                query: {year: this.year}
            });
            return Promise.resolve();
        },
        init() {
            this.isLoaded = false;
            if (this.route.query.year) {
                this.$store.state.year = this.route.query.year;
            }
            this.$store.state.siteId = this.route.params.site_id ? this.route.params.site_id : null;
            this.fetchForms()
                .then(this.configureForms)
                .then(() => {
                    this.isLoaded = true;
                });
        },
        onYearChange(newYear) {
            this.$store.state.year = newYear;
            this.$router.push({
                name: 'site-forms',
                params: {site_id: this.route.params.site_id},
                query: {year: this.year}
            });
        }
    },
    computed: {
        filteredForms() {
            return this.forms.filter(form => {
                return form.formTypeId === this.selectedForm || !this.selectedForm;
            });
        }
    },
    watch: {
        '$store.state.year': function() {
            this.init();
        },
        '$store.state.siteId': function() {
            this.init();
        },
        selectedFormToCreate(newValue) {
            this.$router.push({
                name: 'form-create',
                params: {site_id: this.route.params.site_id, form_type: newValue}
            });
        }
    },
    created() {
        this.init();
        this.selectedSite = _.find(this.sites, {id: Number(this.route.params.site_id)});
        this.filteredSites = this.sites;
    }
};
</script>
<style lang="scss">
.tab-deactive {
    .nav-link {
        background-color: #ddd;
    }
}
</style>

<i18n src="../../../i18n/common.json"></i18n>

<i18n>
    {
        "tr": {
            "title": "FORMLAR",
            "formType": "Form Tipi",
            "formNo": "Form No",
            "version": "Versiyon",
            "createdAt": "Oluşturulma Tarihi",
            "chooseFormType": "Form Tipi Seçin"

    },
        "en": {
            "title": "FORMS",
            "formType": "Form Type",
            "formNo": "Form No",
            "version": "Version",
            "createdAt": "Created At",
            "chooseFormType": "Choose a Form Type"
        }
    }
</i18n>



// WEBPACK FOOTER //
// src/views/Doc/Forms/SiteForms.vue